import moment from "moment";
import http from "../http-common";
import BaseService from "./base.service";

class AnniversaryService extends BaseService {
  constructor() {
    super("anniversary");
  }

  async getHiringByAdminId(params = {}) {
    const adminId = localStorage.getItem("idAdminEnterprise");
    params = {
      ...params,
      userId: localStorage.getItem("userId")
    };
    const response = await http.get(
      `${this.path}/getHiringByAdminId/${adminId}`,
      { params }
    );
    if (Array.isArray(response?.data?.data?.[0]?.docs)) {
      let data = response?.data?.data?.[0];
      data.docs = data.docs.map((doc) => {
        const hiringDate = (doc.defaultDateHiring && doc.seniorityDate) ? doc.seniorityDate : doc.hiringDate;
        const dateActuelle = moment();
        const anneeActuelle = dateActuelle.year();
        const prochainAnniversaire = moment(hiringDate).set(
          "year",
          anneeActuelle
        );
        if (dateActuelle.isAfter(prochainAnniversaire, 'day')) {
          prochainAnniversaire.add(1, "year");
        }
        doc.anniversaryDate = prochainAnniversaire.format("DD/MM/YYYY");
        doc.age = dateActuelle.diff(moment(hiringDate), "years", true);
        return doc;
      });
      data.docs = data.docs.sort((a, b) => moment(a.anniversaryDate, "DD/MM/YYYY").diff(moment(b.anniversaryDate, "DD/MM/YYYY")));
      return data;
    } else {
      return {
        count: 0,
        docs: []
      };
    }
  }

  adjustEmplacementAndDateOfBirth(data = []) {
    const dateActuelle = moment();
    const anneeActuelle = dateActuelle.year();
    for (let value of data) {
      if (value?.emplacement) {
        let emplacementName = [];
        for (let res of value?.emplacement) {
          emplacementName.push(res?.id?.name);
        }
        value.emplacementName = emplacementName?.length
          ? emplacementName.join(", ")
          : "Aucun";
      }

      let dateOfBirth = value.personnalInformation.dateOfBirth;
      const prochainAnniversaire = moment(dateOfBirth).set('year', anneeActuelle);
      if (dateActuelle.isAfter(prochainAnniversaire, 'day')) {
        prochainAnniversaire.add(1, 'year');
      }
      value.anniversaryDate = prochainAnniversaire.format("DD/MM/YYYY");
      value.age = dateActuelle.diff(moment(dateOfBirth), 'years');
    }
    data = data.sort((a, b) => moment(a.anniversaryDate, "DD/MM/YYYY").diff(moment(b.anniversaryDate, "DD/MM/YYYY")));
    return data;
  }

  async getBirthByAdminId(params = {}) {
    const adminId = localStorage.getItem("idAdminEnterprise");
    params = {
      ...params,
      userId: localStorage.getItem("userId")
    };
    const response = await http.get(
      `${this.path}/getBirthByAdminId/${adminId}`,
      { params }
    );
    if (Array.isArray(response?.data?.data?.[0]?.docs)) {
      let data = response?.data?.data?.[0];
      data.docs = this.adjustEmplacementAndDateOfBirth(data.docs);
      return data;
    } else {
      return {
        count: 0,
        docs: []
      };
    }
  }

  async addNote(body) {
    const response = await http.post(`${this.path}/createNote`, body);
    return response?.data?.data;
  }

  async deleteNote(noteId) {
    const response = await http.delete(`${this.path}/deleteOneNote/${noteId}`);
    return response?.data?.data;
  }
}

export const Anniversary = new AnniversaryService();
